/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_IncompleteInputs */

const fr_membership_status_incomplete = /** @type {(inputs: Membership_Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomplet`)
};

/**

* @param {Membership_Status_IncompleteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_incomplete = /** @type {((inputs?: Membership_Status_IncompleteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_IncompleteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_incomplete(inputs)
});